import { render, staticRenderFns } from "./LgFinderPagePerfil.vue?vue&type=template&id=c8d2fe16"
import script from "./LgFinderPagePerfil.vue?vue&type=script&lang=js"
export * from "./LgFinderPagePerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports